import React from "react";
import { motion } from "framer-motion";

const DistinctiveValue = () => {
  return (
    <section className="relative py-20">
      <div 
        className="absolute inset-0 bg-cover bg-center bg-fixed opacity-10"
        style={{ 
          backgroundImage: 'url("/lovable-uploads/ee84d10e-e2b5-4b28-9e36-17737dc1814b.png")',
        }}
      />
      <div className="container mx-auto px-4 relative">
        <motion.div 
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
          className="max-w-4xl mx-auto text-center"
        >
          <h2 className="text-3xl md:text-4xl font-bold mb-8 text-primary">What Makes Us Different</h2>
          <div className="bg-white/95 backdrop-blur-sm p-8 rounded-2xl shadow-xl border border-primary/20">
            <p className="text-lg leading-relaxed italic text-gray-700">
              "The Seed Potato Organization (SPO) is distinct from AHDB Potatoes, as membership is based 
              on voluntary subscriptions rather than a mandated levy. This approach allows the SPO to 
              provide greater value for money and directly address the specific needs of the seed potato 
              sector and its growers. For the SPO to fully achieve its objectives, a high level of 
              participation from the community will be essential."
            </p>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default DistinctiveValue;